import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { VolumeCalculatorComponent } from "../../form-parts/volume-calculator/volume-calculator.component";
import { FormService } from "../../services/form.service";
import { ApiService } from "../../services/api.service";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-moving-boxes',
	templateUrl: './moving-boxes.component.html',
	styleUrls: ['./moving-boxes.component.scss']
})
export class MovingBoxesComponent implements OnInit {

	movingBoxes !: UntypedFormGroup
	formGroupName : string = 'movingBoxes'
	vcPreCategories: any | undefined;

	// volumeM3 values mirror the ERP's baggage-match constants — not geometric volume — to keep front-end and ERP grading in sync.
	public baggageSizes = [
		{
			key: 'boxesSmall',
			title: $localize `Small box`,
			size: '30 x 30 x 30 cm',
			descriptionSizeKg: '11 kg',
			volumeM3: 0.025,
		},
		{
			key: 'boxesMedium',
			title: $localize `Medium box`,
			size: '46 x 46 x 46 cm',
			descriptionSizeKg: '19 kg',
			volumeM3: 0.08,
		},
		{
			key: 'boxesLarge',
			title: $localize `Large box`,
			size: '61 x 46 x 46 cm',
			descriptionSizeKg: '27 kg',
			volumeM3: 0.1,
		}
	];

	private static readonly FT3_PER_M3 = 35.3146667;

	constructor( public formService: FormService ) {

	}

	public ngOnInit(): void {

		this.movingBoxes = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;

		// Recalculate on init so pre-filled values (e.g. back-navigation) stay in sync
		this.calculateVolume();
	}

	ngAfterViewInit() {

		// After view has loaded
	}

	public onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.movingBoxes) );
	}

	//  === Baggage move action === //
	public itemUp( item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var currentVal = currentControl.value;
		currentControl.setValue(++currentVal );
		this.calculateVolume();
	}

	public itemDown( item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var currentVal = currentControl.value;

		if( currentVal <= 0 ) {
			return;
		}

		currentControl.setValue(--currentVal );
		this.calculateVolume();
	}

	public itemInput( event: any,  item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var value = event.target.value;

		// Don't allow lower than 0
		value = ( value < 0 ? 0 : value );
		currentControl.setValue( value );
		this.calculateVolume();
	}

	private calculateVolume(): void {

		var totalM3 = 0;

		for( var size of this.baggageSizes ) {

			var amount = Number( this.movingBoxes.controls[size.key].value ) || 0;
			totalM3 += amount * size.volumeM3;
		}

		// Send the raw value (no rounding) to mirror the ERP formula exactly — the ERP
		// stores re_volume_m3 = $move_m3 unrounded, so rounding here would break parity.
		var m3 = totalM3;
		var ft3 = totalM3 * MovingBoxesComponent.FT3_PER_M3;

		this.movingBoxes.controls['volumeM3'].setValue( m3 );
		this.movingBoxes.controls['volumeFt3'].setValue( ft3 );

		if( totalM3 > 0 ) {

			console.log( '[DEV-5238] movingBoxes volume', {
				boxesSmall: this.movingBoxes.controls['boxesSmall'].value,
				boxesMedium: this.movingBoxes.controls['boxesMedium'].value,
				boxesLarge: this.movingBoxes.controls['boxesLarge'].value,
				volumeM3: m3,
				volumeFt3: ft3,
			} );
		}
	}
}